export const idleTimer = 1000 * 60 * 15; // 15 minutes
export const refreshTimer = 1000 * 60 * 10; // refresh every 10 minutes
